var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{staticClass:"py-0",attrs:{"single-line":""}},[_vm._l((_vm.instances.slice().reverse()),function(item,i){return [_c('span',{key:i},[(item.router)?_c('InstanceLeftMenuAction',{attrs:{"currentInstance":_vm.current_instance,"item":item}}):_vm._e()],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }